export default __webpack_public_path__ + "static/background-sunset-d51ce75a9697c9a583cacfefc6440af2.png";